import { type ReactNode } from "react";
import i18n from "i18next";
import { initReactI18next, I18nextProvider } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import en from "@/i18n/messages/en.json";
import ru from "@/i18n/messages/ru.json";

// Initialize i18next
i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			ru: { translation: ru },
		},
		fallbackLng: "en",
		supportedLngs: ["en", "ru"],
		interpolation: {
			escapeValue: false, // React already escapes
		},
		detection: {
			order: ["cookie", "localStorage", "navigator"],
			caches: ["cookie", "localStorage"],
			cookieMinutes: 60 * 24 * 365, // 1 year
		},
	});

// Set document lang on init and language changes (outside React)
if (typeof document !== "undefined") {
	document.documentElement.lang = i18n.language;
	i18n.on("languageChanged", (lng) => {
		document.documentElement.lang = lng;
		document.cookie = `locale=${lng};path=/;max-age=${60 * 60 * 24 * 365}`;
	});
}

type Locale = "en" | "ru";

interface I18nProviderProps {
	children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
	return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}


